export default [{
    name: 'tj-rili',
    path: '/tj/rili',
    meta: {title: '日历'},
    component: () => import('./views/rili')
}, {
    name: 'tj-list',
    path: '/tj/list',
    meta: {title: '列表'},
    component: () => import('./views/list')
}, {
    name: 'tj-statistics',
    path: '/tj/statistics',
    meta: {title: '统计'},
    component: () => import('./views/statistics')
}, {
    name: 'tj-detail',
    path: '/tj/detail',
    meta: {title: '详情'},
    component: () => import('./views/detail')
},{
    name:'tj-index',
    path:'/tj/index',
    meta:{title:'tj-index'},
    component:()=>import('./views/index')
    },/*replace*/];
